import apiService from "../../api/api.service";
import {
  StoreProductsParams,
  StoreProductsData,
  StoreSellerData,
  ToggleFollowData,
} from "./store.types";
import { ApiResponse } from "../../api/api.types";

export const fetchStoreProductsService = async (
  slug: string,
  params?: StoreProductsParams,
): Promise<ApiResponse<StoreProductsData>> => {
  if (!params) {
    return apiService.get<ApiResponse<StoreProductsData>>(`/stores/${slug}/products`);
  }
  const { tab, page, per_page, search, ...filterFields } = params;
  const filtersClean = Object.fromEntries(
    Object.entries(filterFields).filter(([, v]) => v !== undefined),
  );
  return apiService.get<ApiResponse<StoreProductsData>>(
    `/stores/${slug}/products`,
    {
      params: {
        ...(tab ? { tab } : {}),
        ...(page ? { page } : {}),
        ...(per_page ? { per_page } : {}),
        ...(search ? { search } : {}),
        ...(Object.keys(filtersClean).length ? { filters: filtersClean } : {}),
      },
    },
  );
};

export const fetchStoreSellerService = async (
  slug: string,
): Promise<ApiResponse<StoreSellerData>> => {
  return apiService.get<ApiResponse<StoreSellerData>>(`/stores/${slug}`);
};

export const toggleStoreFollowService = async (
  id: number,
): Promise<ApiResponse<ToggleFollowData>> => {
  return apiService.post<ApiResponse<ToggleFollowData>>(
    `/stores/${id}/toggle-follow`,
  );
};
